import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { usePrompt } from '../App';

const CharacterSelect = () => {
  const navigate = useNavigate();
  const { anime } = useParams();
  const { selectedAnime, setSelectedCharacter, telegramUser } = usePrompt();

  const [showModal, setShowModal] = useState(false); // Для модального окна
  const [isChecking, setIsChecking] = useState(false); // Для состояния загрузки API

  // API для проверки подписки
  const checkSubscription = async (userId) => {
    try {
      const response = await fetch(`/api/subscription/${userId}`);
      if (!response.ok) throw new Error('Ошибка сервера');
      const data = await response.json();
      return data.isSubscribed || false;
    } catch (error) {
      console.error('Ошибка проверки подписки:', error);
      return telegramUser?.isSubscribed || false; // Запасной вариант
    }
  };

  const charactersByAnime = {
    naruto: [
      { name: 'Sakura Haruno', image: '/images/characters/sakura.jpg', isAdult: false },
      { name: 'Hyuuga Hinata', image: '/images/characters/hinata.jpg', isAdult: false },
      { name: 'Tsunade', image: '/images/characters/tsunade.jpg', isAdult: false },
      { name: 'Yamanaka Ino', image: '/images/characters/ino.jpg', isAdult: false },
      { name: 'Nara Temari', image: '/images/characters/tamari.jpg', isAdult: false },
      { name: 'Konan (Naruto)', image: '/images/characters/Konan.jpg', isAdult: false },
      { name: 'terumi mei from Naruto', image: '/images/characters/terumi.jpg', isAdult: false },
      { name: 'Samui from Naruto', image: '/images/characters/samui.jpg', isAdult: false },
      { name: 'Tenten from Naruto', image: '/images/characters/tenten.jpg', isAdult: false },

    ],
    bleach: [
      { name: 'Rukia Kuchiki', image: '/images/characters/Rukia.jpg', isAdult: false },
      { name: 'Orihime Inoue', image: '/images/characters/Orihime.jpg', isAdult: false },
      { name: 'Rangiku Matsumoto', image: '/images/characters/Rangiku.jpg', isAdult: false },
      { name: 'Yoruichi Shihouin', image: '/images/characters/Yoruichi.jpg', isAdult: false },
      { name: 'Unohana Retsu from Bleach', image: '/images/characters/unohana.jpg', isAdult: false },
      { name: 'Nelliel Tu Odelschwanck from bleach', image: '/images/characters/nelliel.jpg', isAdult: false },
    ],
    onepiece: [
      { name: 'Boa Hancock', image: '/images/characters/Boa.jpg', isAdult: false },
      { name: 'Nami (one Piece)', image: '/images/characters/nami.jpg', isAdult: false },
      { name: 'Nico Robin', image: '/images/characters/nico.jpg', isAdult: false },
      { name: 'Yamato from one piece', image: '/images/characters/yamato.jpg', isAdult: false },
      { name: 'Perona from one piece', image: '/images/characters/perona.jpg', isAdult: false },
      { name: 'ulti from one piece', image: '/images/characters/ulti.jpg', isAdult: false },
      { name: 'Uta from one piece', image: '/images/characters/uta.jpg', isAdult: false },
    ],
    fairytail: [
      { name: 'Erza Scarlet', image: '/images/characters/Erza.jpg', isAdult: false },
      { name: 'Lucy Heartfilia', image: '/images/characters/lucy.jpg', isAdult: false },
      { name: 'Juvia Lockser', image: '/images/characters/juvia.jpg', isAdult: false },
      { name: 'Mirajane Strauss', image: '/images/characters/mirajane.jpg', isAdult: false },
      { name: 'levy mcgarden', image: '/images/characters/levy.jpg', isAdult: false },
      { name: 'wendy marvell', image: '/images/characters/wendy.jpg', isAdult: false },
    ],
    genshin: [
      { name: 'Barbara Pegg', image: '/images/characters/pegg.jpg', isAdult: false },
      { name: 'Ningguang', image: '/images/characters/ning.jpg', isAdult: false },
      { name: 'Beidou', image: '/images/characters/Beidou.jpg', isAdult: false },
      { name: 'Ganyu', image: '/images/characters/Ganyu.jpg', isAdult: false },
      { name: 'Jean Gunnhildr', image: '/images/characters/jean.jpg', isAdult: false },
      { name: 'Dehya', image: '/images/characters/Dehya.jpg', isAdult: false },
      { name: 'Yelan', image: '/images/characters/yelan.jpg', isAdult: false },
      { name: 'Keqing', image: '/images/characters/keqing.jpg', isAdult: false },
      { name: 'Candace', image: '/images/characters/candace.jpg', isAdult: false },
      { name: 'Lisa Minci', image: '/images/characters/lisa.jpg', isAdult: false },
      { name: 'Rosaria from Genshin Impact', image: '/images/characters/rozaria.jpg', isAdult: false },
      { name: 'Shenhe', image: '/images/characters/shenhe.jpg', isAdult: false },
      { name: 'Yae Miko', image: '/images/characters/yae.jpg', isAdult: false },
      { name: 'Raiden Shogun', image: '/images/characters/raiden.jpg', isAdult: false },
      { name: 'Xinyan', image: '/images/characters/xin.jpg', isAdult: false },
      { name: 'Furina', image: '/images/characters/furina.jpg', isAdult: false },
      { name: 'Hu Tao', image: '/images/characters/hu.jpg', isAdult: false },
      { name: 'lumine', image: '/images/characters/lumine.jpg', isAdult: false },
      { name: 'Nilou', image: '/images/characters/nilou.jpg', isAdult: false },
      { name: 'Kujou Sara from genshin impact', image: '/images/characters/kujou.jpg', isAdult: false },
      { name: 'mona from Genshin Impact', image: '/images/characters/mona.jpg', isAdult: false },
      { name: 'Columbina from genshin impact', image: '/images/characters/columbina.jpg', isAdult: false },
      { name: 'Eula from genshin impact', image: '/images/characters/eula.jpg', isAdult: false },
    ],
    other: [
      { name: 'Rem (Re:Zero)', image: '/images/characters/rem.jpg', isAdult: false },
      { name: 'Ram (Re:Zero)', image: '/images/characters/ram.jpg', isAdult: false },
      { name: 'Mikasa Ackerman', image: '/images/characters/mikasa.jpg', isAdult: false },
      { name: 'annie leonhart from attack on titan', image: '/images/characters/annie.jpg', isAdult: false },
      { name: 'Power (Chainsaw Man)', image: '/images/characters/power.jpg', isAdult: false },
      { name: 'yoru from chainsaw man', image: '/images/characters/yoru.jpg', isAdult: false },
      { name: 'Zero Two (Darling in the Franxx)', image: '/images/characters/zero.jpg', isAdult: false },
      { name: 'Frieren', image: '/images/characters/frieren.jpg', isAdult: false },
      { name: 'Fern from Frieren: Beyond Journey End', image: '/images/characters/fern.jpg', isAdult: false },
      { name: 'Saber', image: '/images/characters/saber.jpg', isAdult: false },
      { name: 'Asuna (SAO)', image: '/images/characters/asuna.jpg', isAdult: false },
      { name: 'Leafa', image: '/images/characters/leafa.jpg', isAdult: false },
      { name: 'suguha from Sword art online', image: '/images/characters/suguha.jpg', isAdult: false },
      { name: 'Sinon from sao', image: '/images/characters/sinon.jpg', isAdult: false },
      { name: 'Zelda', image: '/images/characters/zelda.jpg', isAdult: false },      
      { name: 'Purah from zelda', image: '/images/characters/purah.jpg', isAdult: false },
      { name: 'Yor Briar', image: '/images/characters/yor.jpg', isAdult: false },
      { name: 'Fiona Frost from SPYxFAMILY', image: '/images/characters/fiona.jpg', isAdult: false },
      { name: 'Nezuko Kamado', image: '/images/characters/nezuko.jpg', isAdult: false },
      { name: 'Kochou shinobu', image: '/images/characters/kochou.jpg', isAdult: false },
      { name: 'Sailor Moon', image: '/images/characters/sailor.jpg', isAdult: false },
      { name: 'Yuri (Doki Doki Literature club)', image: '/images/characters/yuri.jpg', isAdult: false },
      { name: 'Miku Hatsune', image: '/images/characters/miku.jpg', isAdult: false },
      { name: 'Lala Satalin Deviluke', image: '/images/characters/lala.jpg', isAdult: false },
      { name: 'Nagatoro hayase', image: '/images/characters/nagatoro.jpg', isAdult: false },
      { name: 'Bulma', image: '/images/characters/bulma.jpg', isAdult: false },
      { name: 'Android 21', image: '/images/characters/android.jpg', isAdult: false },
      { name: 'Android 18', image: '/images/characters/andr.jpg', isAdult: false },
      { name: 'Inui Sajuna', image: '/images/characters/inui.jpg', isAdult: false },
      { name: 'Mitsuri Kanroji', image: '/images/characters/mits.jpg', isAdult: false },
      { name: 'Darkness from Konosuba', image: '/images/characters/dark.jpg', isAdult: false },
      { name: 'Aqua (Konosuba)', image: '/images/characters/aqua.jpg', isAdult: false },
      { name: 'Wiz from konosuba', image: '/images/characters/wiz.jpg', isAdult: false },
      { name: 'Esdeath from Akame ga Kill!', image: '/images/characters/ezd.jpg', isAdult: false },
      { name: 'Tatsumaki', image: '/images/characters/tatsumaki.jpg', isAdult: false },
      { name: 'Fubuki from one punch man', image: '/images/characters/fubuki.jpg', isAdult: false },
      { name: 'Soraka', image: '/images/characters/soraka.jpg', isAdult: false },
      { name: '2b (nier:automata)', image: '/images/characters/2b.jpg', isAdult: false },
      { name: 'chun-li from street fihgter2', image: '/images/characters/chunli.jpg', isAdult: false },
      { name: 'Cammy White', image: '/images/characters/cammy.jpg', isAdult: false },
      { name: 'Sakura Kasugano from Street Fighter', image: '/images/characters/kasugano.jpg', isAdult: false },
      { name: 'Kazama asuka from tekken', image: '/images/characters/kazama.jpg', isAdult: false },
      { name: 'Juri han from street-fighter 6', image: '/images/characters/juri.jpg', isAdult: false },
      { name: 'Ayanami Rei', image: '/images/characters/rei.jpg', isAdult: false },
      { name: 'Sona from League of Legend', image: '/images/characters/sona.jpg', isAdult: false },
      { name: 'Nidalee from League of Legend', image: '/images/characters/nidalee.jpg', isAdult: false },
      { name: 'Ahri (League of Legend)', image: '/images/characters/ahri.jpg', isAdult: false },
      { name: 'Neeko from league of legends', image: '/images/characters/neeko.jpg', isAdult: false },
      { name: 'Caitlyn kiramman from League of Legend', image: '/images/characters/caitlyn.jpg', isAdult: false },
      { name: 'Zoe from League Of Legends', image: '/images/characters/zoe.jpg', isAdult: false },
      { name: 'Tristana  from league of legends', image: '/images/characters/tristana.jpg', isAdult: false },
      { name: 'Gwen from league of legends', image: '/images/characters/gwenl.jpg', isAdult: false },
      { name: 'Erina Nakiri', image: '/images/characters/erina.jpg', isAdult: false },
      { name: 'nakiri alice from shokugeki no souma', image: '/images/characters/nakiri.jpg', isAdult: false },
      { name: 'Eris Greyrat', image: '/images/characters/eris.jpg', isAdult: false },
      { name: 'Sylphiette', image: '/images/characters/sylphiette.jpg', isAdult: false },
      { name: 'Nonna from (Girls and Panzer)', image: '/images/characters/nona.jpg', isAdult: false },
      { name: 'yukari akiyama from (Girls and Panzer)', image: '/images/characters/yukari.jpg', isAdult: false },
      { name: 'Jinx', image: '/images/characters/jinx.jpg', isAdult: false },
      { name: 'Albedo (Overlord)', image: '/images/characters/albedo.jpg', isAdult: false },
      { name: 'Shalltear Bloodfallen', image: '/images/characters/shalltear.jpg', isAdult: false },
      { name: 'Rin Tohsaka', image: '/images/characters/rin.jpg', isAdult: false },
      { name: 'hoshino ai', image: '/images/characters/ai.jpg', isAdult: false },
      { name: 'Raphtalia', image: '/images/characters/Raphtalia.jpg', isAdult: false },
      { name: 'Kurokawa Akane from Oshi no Ko', image: '/images/characters/Kurokawa.jpg', isAdult: false },
      { name: 'Busujima Saeko', image: '/images/characters/Saeko.jpg', isAdult: false },
      { name: 'Takagi Saya from HOTD', image: '/images/characters/takagi.jpg', isAdult: false },
      { name: 'Winry Rockbell', image: '/images/characters/Winry.jpg', isAdult: false },
      { name: 'Marikawa Shizuka from Highschool of the Dead', image: '/images/characters/Marikawa.jpg', isAdult: false },
      { name: 'Matoi Ryuuko', image: '/images/characters/Matoi.jpg', isAdult: false },
      { name: 'Satsuki kiryuin from kill la kill', image: '/images/characters/satsuki.jpg', isAdult: false },
      { name: 'Inori Yuzuriha from Guilty Crown', image: '/images/characters/Inori.jpg', isAdult: false },
      { name: 'holo from Ookami to Koushinryou: Merchant Meets the Wise Wolf', image: '/images/characters/holo.jpg', isAdult: false },
      { name: 'Revy from Black Lagoon', image: '/images/characters/Revy.jpg', isAdult: false },
      { name: 'Lucy from Elfen Lied', image: '/images/characters/Lucyelfen.jpg', isAdult: false },
      { name: 'Hibana from Enen no Shouboutai', image: '/images/characters/Hibana.jpg', isAdult: false },
      { name: 'Roxy Migurdia', image: '/images/characters/Roxy.jpg', isAdult: false },
      { name: 'Hana Midorikawa from Prison School', image: '/images/characters/Hana.jpg', isAdult: false },
      { name: 'Mari Kurihara from Prison School', image: '/images/characters/Mari.jpg', isAdult: false },
      { name: 'Marin Kitagawa', image: '/images/characters/marin.jpg', isAdult: false },
      { name: 'Rachel Gardner from Satsuriku no Tenshi', image: '/images/characters/Rachel.jpg', isAdult: false },
      { name: 'Kaguya Shinomiya', image: '/images/characters/Kaguya.jpg', isAdult: false },
      { name: 'Ishtar', image: '/images/characters/Ishtar.jpg', isAdult: false },
      { name: 'Re-l Mayer from Ergo Proxy', image: '/images/characters/Re.jpg', isAdult: false },
      { name: 'Megumin', image: '/images/characters/Megumin.jpg', isAdult: false },
      { name: 'Miyuki Shiba from Mahouka Koukou no Rettousei', image: '/images/characters/Miyuki.jpg', isAdult: false },
      { name: 'Bridget Satellizer from Freezing', image: '/images/characters/Bridget.jpg', isAdult: false },
      { name: 'Mai Sakurajima', image: '/images/characters/Mai.jpg', isAdult: false },
      { name: 'Siesta from Tantei wa Mou, Shindeiru', image: '/images/characters/Siesta.jpg', isAdult: false },
      { name: 'Sumireko Sanshokuin from Ore wo Suki nano wa Omae dake ka yo', image: '/images/characters/Sumireko.jpg', isAdult: false },
      { name: 'Tsubasa Hanekawa from monogatari', image: '/images/characters/Tsubasa.jpg', isAdult: false },
      { name: 'Hitagi Senjougahara from monogatari', image: '/images/characters/Hitagi.jpg', isAdult: false },
      { name: 'Shinobu Oshino from monogatari', image: '/images/characters/Shinobu.jpg', isAdult: false },
      { name: 'Tifa Lockhart', image: '/images/characters/tifa.jpg', isAdult: false },
      { name: 'Aerith Gainsborough', image: '/images/characters/aerith.jpg', isAdult: false },
      { name: 'Viera from Final Fantasy', image: '/images/characters/viera.jpg', isAdult: false },
      { name: 'Samus Aran', image: '/images/characters/aran.jpg', isAdult: false },
      { name: 'Ranni the witch from elden ring', image: '/images/characters/ranni.jpg', isAdult: false },
      { name: 'Melina from elden ring', image: '/images/characters/melina.jpg', isAdult: false },
      { name: 'Bayonetta', image: '/images/characters/bayonetta.jpg', isAdult: false },
      { name: 'Himejima akeno from dxd', image: '/images/characters/himejima.jpg', isAdult: false },
      { name: 'ravel phenex from dxd', image: '/images/characters/ravel.jpg', isAdult: false },
      { name: 'kuroka from dxd', image: '/images/characters/kuroka.jpg', isAdult: false },
      { name: 'Elsa from frozen', image: '/images/characters/elsa.jpg', isAdult: false },
      { name: 'Nobara Kugisaki', image: '/images/characters/nobara.jpg', isAdult: false },
      { name: 'Mushoku tensei ghislaine', image: '/images/characters/mushoku.jpg', isAdult: false }, 
      { name: 'Harley Quinn', image: '/images/characters/harley.jpg', isAdult: false },
      { name: 'Hestia danmachi', image: '/images/characters/hestia.jpg', isAdult: false },      
      { name: 'Princess Peach', image: '/images/characters/peach.jpg', isAdult: false },
      { name: 'Bowsette', image: '/images/characters/bowsette.jpg', isAdult: false },
      { name: 'Yang Xiao-Long from RWBY', image: '/images/characters/yang.jpg', isAdult: false },
      { name: 'Ruby Rose from RWBY', image: '/images/characters/Ruby.jpg', isAdult: false },
      { name: 'Weiss Schnee from RWBY', image: '/images/characters/weiss.jpg', isAdult: false },
      { name: 'Komi', image: '/images/characters/komi.jpg', isAdult: false },
      { name: 'Takanashi Kiara', image: '/images/characters/kiara.jpg', isAdult: false },
      { name: 'Mori calliope', image: '/images/characters/mori.jpg', isAdult: false },
      { name: 'Ramlethal from guilty gear', image: '/images/characters/ramlethal.jpg', isAdult: false },
      { name: 'May from guilty gear', image: '/images/characters/may.jpg', isAdult: false },
      { name: 'Bridget from guilty gear', image: '/images/characters/bridgetg.jpg', isAdult: false },
      { name: 'Baiken from guilty gear', image: '/images/characters/baiken.jpg', isAdult: false },
      { name: 'giovanna from guilty gear', image: '/images/characters/giovanna.jpg', isAdult: false },
      { name: 'Ann Takamaki Persona 5', image: '/images/characters/takamaki.jpg', isAdult: false },
      { name: 'rise kujikawa from persona', image: '/images/characters/rise.jpg', isAdult: false },
      { name: 'Olga dark elf discordia kuroinu', image: '/images/characters/olga.jpg', isAdult: false },
      { name: 'Shirase sakuya from idol master', image: '/images/characters/shirase.jpg', isAdult: false },
      { name: 'Cerestia of life from lastorigin', image: '/images/characters/cerestia.jpg', isAdult: false },
      { name: 'shiranui Mai', image: '/images/characters/maishir.jpg', isAdult: false },
      { name: 'charlie morningstar from hazbin hotel', image: '/images/characters/charlie.jpg', isAdult: false },
      { name: 'Jessica Rabbit', image: '/images/characters/jessica.jpg', isAdult: false },
      { name: 'Lucy from Cyberpunk', image: '/images/characters/lucycy.jpg', isAdult: false },
      { name: 'Rebecca from cyberpunk', image: '/images/characters/rebecca.jpg', isAdult: false },
      { name: 'Hilda valentine goneril', image: '/images/characters/hilda.jpg', isAdult: false },
      { name: 'Marianne von edmund', image: '/images/characters/marianne.jpg', isAdult: false },
      { name: 'Edelgard von hresvelg', image: '/images/characters/edelgard.jpg', isAdult: false },
      { name: 'Daiwa scarlet from uma musume', image: '/images/characters/daiwa.jpg', isAdult: false },
      { name: 'Miia from monster musume,lamia body type', image: '/images/characters/miia.jpg', isAdult: false },
      { name: 'Centorea Shianus from monster musume,centaur', image: '/images/characters/centorea.jpg', isAdult: false },
      { name: 'Rachnera Arachnera from monster musume', image: '/images/characters/rachnera.jpg', isAdult: false },
      { name: 'Papi from monster musume,harpy', image: '/images/characters/papi.jpg', isAdult: false },
      { name: 'Velma', image: '/images/characters/velma.jpg', isAdult: false },
      { name: 'Makoto Nanaya from Blazblue', image: '/images/characters/makoto.jpg', isAdult: false },
      { name: 'Noel Vermillion from Blazblue', image: '/images/characters/noel.jpg', isAdult: false }, 
      { name: 'Litchi Faye-Ling from Blazblue', image: '/images/characters/litchi.jpg', isAdult: false }, 
      { name: 'Rachel Alucard from Blazblue', image: '/images/characters/alucard.jpg', isAdult: false },
      { name: 'Spider Gwen from SpiderVerse,undercut blonde hair with pink highlights', image: '/images/characters/gwen.jpg', isAdult: false },
      { name: 'Morrigan Aensland', image: '/images/characters/morrigan.jpg', isAdult: false },
      { name: 'Tharja from fire emblem', image: '/images/characters/tharja.jpg', isAdult: false },
      { name: 'Prinz eugen from azur lane', image: '/images/characters/prinz.jpg', isAdult: false },
      { name: 'Baltimore From Azur Lane', image: '/images/characters/baltimore.jpg', isAdult: false },
      { name: 'Atago azur lane', image: '/images/characters/atago.jpg', isAdult: false },
      { name: 'Formidable azur lane', image: '/images/characters/formidable.jpg', isAdult: false },
      { name: 'Ashido mina from my hero academia', image: '/images/characters/ashido.jpg', isAdult: false }, 
      { name: 'Mount lady from my hero academia', image: '/images/characters/mount.jpg', isAdult: false },
      { name: 'Marinette from miraculous ladybug', image: '/images/characters/ladybug.jpg', isAdult: false }, 
      { name: 'Cornelia li britannia from code geass', image: '/images/characters/cornelia.jpg', isAdult: false },
      { name: 'kallen kozuki from code geass', image: '/images/characters/kallen.jpg', isAdult: false },
      { name: 'Wednesday addams', image: '/images/characters/wednesday.jpg', isAdult: false },
      { name: 'Nyotengu from doa', image: '/images/characters/nyotengu.jpg', isAdult: false },
      { name: 'Honoka from doa', image: '/images/characters/honoka.jpg', isAdult: false }, 
      { name: 'Kasumi from DoA', image: '/images/characters/kasumi.jpg', isAdult: false },
      { name: 'Ayane from DoA', image: '/images/characters/ayane.jpg', isAdult: false },
      { name: 'Ariel from disney', image: '/images/characters/ariel.jpg', isAdult: false }, 
      { name: 'Snow White from disney', image: '/images/characters/snow.jpg', isAdult: false },
      { name: 'Disney Cinderella', image: '/images/characters/cinderella.jpg', isAdult: false },
      { name: 'Alice from Alice in wonderland, Alice from disney', image: '/images/characters/alice.jpg', isAdult: false },
      { name: 'Princess Jasmine From Aladdin', image: '/images/characters/jasmine.jpg', isAdult: false },
      { name: 'Rapunzel from disney', image: '/images/characters/rapunzel.jpg', isAdult: false },
      { name: 'Mavis Dracula From Hotel Transylvania', image: '/images/characters/mavis.jpg', isAdult: false },
      { name: 'Isabella valentine from soul calibur', image: '/images/characters/isabella.jpg', isAdult: false },
      { name: 'Lara croft', image: '/images/characters/croft.jpg', isAdult: false },
      { name: 'violet parr from the incredibles', image: '/images/characters/parr.jpg', isAdult: false },
      { name: 'Gwen Tennyson from Ben 10', image: '/images/characters/gwenten.jpg', isAdult: false },
      { name: 'Vicky from fairly oddparents', image: '/images/characters/vicky.jpg', isAdult: false },
      { name: 'Cortana', image: '/images/characters/cortana.jpg', isAdult: false },
      { name: 'Catwoman', image: '/images/characters/catwoman.jpg', isAdult: false },
      { name: 'Poison ivy', image: '/images/characters/ivy.jpg', isAdult: false },
      { name: '(Gravity Falls)Mabel Pines', image: '/images/characters/mabel.jpg', isAdult: false },
      { name: 'Miyamoto musashi fate grand order', image: '/images/characters/miyamoto.jpg', isAdult: false },
      { name: 'Scheherazade fate grand order', image: '/images/characters/scheherazade.jpg', isAdult: false }, 
      { name: 'Scathach from Fate Grand Order', image: '/images/characters/scathach.jpg', isAdult: false },
      { name: 'Morgan Le Fay from fate ground order', image: '/images/characters/morgan.jpg', isAdult: false }, 
      { name: 'artoria lancer alter from fate grand order', image: '/images/characters/artoria.jpg', isAdult: false },
      { name: 'Minamoto No Raikou Fate', image: '/images/characters/minamoto.jpg', isAdult: false },
      { name: 'Chloe Von Einzbern From Fate', image: '/images/characters/chloe.jpg', isAdult: false },
      { name: 'kama fate grand order', image: '/images/characters/kama.jpg', isAdult: false },
      { name: 'Elina from queens blade', image: '/images/characters/elina.jpg', isAdult: false },
      { name: 'Cattleya From Queens blade', image: '/images/characters/cattleya.jpg', isAdult: false },
      { name: 'Igawa asagi from taimanin asagi', image: '/images/characters/igawa.jpg', isAdult: false },
      { name: 'ingrid from taimanin', image: '/images/characters/ingrid.jpg', isAdult: false },
      { name: 'Fujiwara Chika from(kaguya-sama love is war)', image: '/images/characters/chika.jpg', isAdult: false },
      { name: 'shirogane noel', image: '/images/characters/shirogane.jpg', isAdult: false },
      { name: 'Sasaki chiho from Hataraku maou sama', image: '/images/characters/sasaki.jpg', isAdult: false },
      { name: 'mimosa from black clover', image: '/images/characters/mimosa.jpg', isAdult: false },
      { name: 'Felicia hardy from marvel', image: '/images/characters/felicia.jpg', isAdult: false },
      { name: 'Scarlet Witch Marvel', image: '/images/characters/scarlet.jpg', isAdult: false },
      { name: 'raven from titans', image: '/images/characters/raven.jpg', isAdult: false },
      { name: 'rory mercury gate jieitai kanochi nite', image: '/images/characters/rory.jpg', isAdult: false },
      { name: 'Samsung Sam', image: '/images/characters/sam.jpg', isAdult: false },
      { name: 'Reimu hakurei from touhou', image: '/images/characters/reimu.jpg', isAdult: false },
      { name: 'izumi sagiri', image: '/images/characters/izumi.jpg', isAdult: false },
      { name: 'Rouge the bat from sonic the hedgehog', image: '/images/characters/rouge.jpg', isAdult: false },
      { name: 'nakano miku from gotoubun no hanayome', image: '/images/characters/nakano.jpg', isAdult: false },
      { name: 'nakano ichika from gotoubun no hanayome', image: '/images/characters/ichika.jpg', isAdult: false },
      { name: 'taiga aisaka from toradora', image: '/images/characters/taiga.jpg', isAdult: false },
      { name: 'Motoko Kusanagi From Ghost In The Shell', image: '/images/characters/motoko.jpg', isAdult: false },
      { name: 'palutena from icarus', image: '/images/characters/palutena.jpg', isAdult: false },
      { name: 'lum from urusei yatsura', image: '/images/characters/lum.jpg', isAdult: false },
      { name: 'tsuki uzaki', image: '/images/characters/tsuki.jpg', isAdult: false },
      { name: 'stocking anarchy from panty and stocking', image: '/images/characters/stockinga.jpg', isAdult: false },
      { name: 'yoko littner from gurren lagann', image: '/images/characters/yoko.jpg', isAdult: false },
      { name: 'iori rinko from gundam', image: '/images/characters/iori.jpg', isAdult: false },
      { name: 'Pyra from xenoblade', image: '/images/characters/pyra.jpg', isAdult: false },
      { name: 'Mythra from xenoblade', image: '/images/characters/mythra.jpg', isAdult: false },
      { name: 'kohaku from dr stone', image: '/images/characters/kohaku.jpg', isAdult: false },
      { name: 'kashima kancolle', image: '/images/characters/kashima.jpg', isAdult: false },
      { name: 'Libeccio from kancolle', image: '/images/characters/libeccio.jpg', isAdult: false },
      { name: 'tenryuu from kancolle', image: '/images/characters/tenryuu.jpg', isAdult: false },
      { name: 'reisalin stout atelier ryza', image: '/images/characters/reisalin.jpg', isAdult: false },
      { name: 'anis from goddess of victory nikke', image: '/images/characters/anis.jpg', isAdult: false },
      { name: 'Casca from Berserk', image: '/images/characters/casca.jpg', isAdult: false },
      { name: 'alexstrasza', image: '/images/characters/alexstrasza.jpg', isAdult: false },
      { name: 'marina from splatoon', image: '/images/characters/marina.jpg', isAdult: false },
      { name: 'Marie from splatoon', image: '/images/characters/marine.jpg', isAdult: false },
      { name: 'Kim possible', image: '/images/characters/kim.jpg', isAdult: false },
      { name: 'Pine bombergirl from bomberman', image: '/images/characters/pine.jpg', isAdult: false },
      { name: 'Violet Evergarden', image: '/images/characters/violet.jpg', isAdult: false },
      { name: 'hamakaze kantai', image: '/images/characters/hamakaze.jpg', isAdult: false },
      { name: 'Wonder woman', image: '/images/characters/wonder.jpg', isAdult: false },
      { name: 'Supergirl', image: '/images/characters/supergirl.jpg', isAdult: false },
      { name: 'Sword maiden', image: '/images/characters/sword.jpg', isAdult: false },
      { name: 'high elf archer from goblin slayer', image: '/images/characters/highelf.jpg', isAdult: false },
      { name: 'tomoe mami from mahou shoujo madoka magica', image: '/images/characters/tomoe.jpg', isAdult: false },
      { name: 'Seras Victoria(Hellsing)', image: '/images/characters/seras.jpg', isAdult: false },
      { name: 'loona from helluva boss,furry', image: '/images/characters/loona.jpg', isAdult: false },
      { name: 'Shermie from KOF', image: '/images/characters/shermie.jpg', isAdult: false },
      { name: 'Isuzu Sento from Amagi Brilliant Park', image: '/images/characters/isuzu.jpg', isAdult: false },
      { name: 'miko kobuta from glitch techs', image: '/images/characters/miko.jpg', isAdult: false },
      { name: 'Hermione Granger', image: '/images/characters/hermione.jpg', isAdult: false },
      { name: 'Angewomon fron digimon adventure', image: '/images/characters/angewomon.jpg', isAdult: false },
      { name: 'lady devimon from digimon', image: '/images/characters/ladydigimon.jpg', isAdult: false },
      { name: 'kat from gravity rush', image: '/images/characters/kat.jpg', isAdult: false },
      { name: 'Neferpitou From Hunter X Hunter', image: '/images/characters/neferpitou.jpg', isAdult: false },
      { name: 'ryougi shiki kara no kyoukai', image: '/images/characters/ryougi.jpg', isAdult: false },
      { name: 'galko from oshiete! galko-chan', image: '/images/characters/galko.jpg', isAdult: false },
      { name: 'tsukikage yuri', image: '/images/characters/tsukikage.jpg', isAdult: false },
      { name: 'Daiichi Ruby from Umamusume', image: '/images/characters/daiichi.jpg', isAdult: false },
      { name: 'gold ship from umamusume', image: '/images/characters/gold.jpg', isAdult: false },
      { name: 'shgiure from kancolle', image: '/images/characters/shgiure.jpg', isAdult: false },
      { name: 'Krul Tepes from owarinoseraph', image: '/images/characters/krul.jpg', isAdult: false },
      { name: 'Juufuutei Raden', image: '/images/characters/juufuutei.jpg', isAdult: false },
      { name: 'Cure Macaron', image: '/images/characters/cure.jpg', isAdult: false },
      { name: 'Cure Chocolat', image: '/images/characters/chocolat.jpg', isAdult: false },
      { name: 'cure black from hutari ha precure', image: '/images/characters/cureb.jpg', isAdult: false },
      { name: 'Jibril from No Game No Life', image: '/images/characters/jibril.jpg', isAdult: false },
      { name: 'irisviel von einzbern', image: '/images/characters/irisviel.jpg', isAdult: false },
      { name: 'Rio from blue archive', image: '/images/characters/rio.jpg', isAdult: false },
      { name: 'Kirara from blue archive', image: '/images/characters/kirara.jpg', isAdult: false },
      { name: 'Kakudate Karin from blue archive', image: '/images/characters/kakudate.jpg', isAdult: false },
      { name: 'Milim nava from tensura', image: '/images/characters/milim.jpg', isAdult: false },
      { name: 'mouri ran from detective conan', image: '/images/characters/mouri.jpg', isAdult: false },
      { name: 'Makoto nijima', image: '/images/characters/makotoni.jpg', isAdult: false },
      { name: 'Inugami korone', image: '/images/characters/inugami.jpg', isAdult: false },
      { name: 'ikaros from Sora No Otoshimono', image: '/images/characters/ikaros.jpg', isAdult: false },
      { name: 'Suzumiya haruhi', image: '/images/characters/suzumiya.jpg', isAdult: false },
      { name: 'W from arknights', image: '/images/characters/w.jpg', isAdult: false },
      { name: 'Ashley graves', image: '/images/characters/ashley.jpg', isAdult: false },
      { name: 'nekomusume from gegege no kitarou', image: '/images/characters/nekomusume.jpg', isAdult: false },
      { name: 'kiyoko shimizu from haikyuu', image: '/images/characters/kiyoko.jpg', isAdult: false },
      { name: 'amanogawa kirara', image: '/images/characters/amanogawa.jpg', isAdult: false },
      { name: 'Sadako', image: '/images/characters/sadako.jpg', isAdult: false },
      { name: 'inoue takina from lycoris recoil', image: '/images/characters/inoue.jpg', isAdult: false },
      { name: 'pomni from the amazing digital circus', image: '/images/characters/pomni.jpg', isAdult: false },
      { name: 'takane lui from vtuber', image: '/images/characters/takane.jpg', isAdult: false },
      { name: 'Arima Kana From oshi no ko', image: '/images/characters/arima.jpg', isAdult: false },
      { name: 'Minoto From Monster Hunter', image: '/images/characters/minoto.jpg', isAdult: false },
      { name: 'Shirai Kuroko', image: '/images/characters/shirai.jpg', isAdult: false },
      { name: 'Yakumo Yukari', image: '/images/characters/yakumo.jpg', isAdult: false },
      { name: 'mercedes von martritz from fire emblem', image: '/images/characters/mercedes.jpg', isAdult: false },
      { name: 'Maomao From Kusuriya Hitorigoto', image: '/images/characters/maomao.jpg', isAdult: false },
      { name: 'usami sumireko', image: '/images/characters/usami.jpg', isAdult: false },
      { name: 'Oosuki Mamako', image: '/images/characters/mamako.jpg', isAdult: false },
      { name: 'Kanu Unchou Ikkitousen', image: '/images/characters/kanu.jpg', isAdult: false },
      { name: 'yorumi rena vtuber', image: '/images/characters/yorumi.jpg', isAdult: false },
      { name: 'Sorceress from dragon crown', image: '/images/characters/dragon.jpg', isAdult: false },
      { name: 'Makise Kurisu', image: '/images/characters/kurisu.jpg', isAdult: false },


    ],
    general: [
      { name: 'Girl', image: '/images/characters/girl.jpg', isAdult: false },
      { name: 'Woman', image: '/images/characters/woman.jpg', isAdult: false },
      { name: 'Milf', image: '/images/characters/milf.jpg', isAdult: true },
      { name: 'Demon', image: '/images/characters/demon.jpg', isAdult: false },
      { name: 'Monster', image: '/images/characters/monster.jpg', isAdult: false },
      { name: 'Goblin', image: '/images/characters/goblin.jpg', isAdult: false },
      { name: 'Orc', image: '/images/characters/orc.jpg', isAdult: false },
      { name: 'Elf', image: '/images/characters/elf.jpg', isAdult: false },
      { name: 'Dark Elf', image: '/images/characters/delf.jpg', isAdult: false },
      { name: '1Boy,boy', image: '/images/characters/boy.jpg', isAdult: false },
      { name: 'Catgirl', image: '/images/characters/catgirl.jpg', isAdult: false },
      { name: '1Man,man', image: '/images/characters/man.jpg', isAdult: false },
      { name: 'Werewolf', image: '/images/characters/werewolf.jpg', isAdult: false },
      { name: 'Minotaur', image: '/images/characters/minotaur.jpg', isAdult: false },
      { name: 'Mom', image: '/images/characters/mom.jpg', isAdult: false },      
      { name: 'Succubus', image: '/images/characters/succubus.jpg', isAdult: false },
      { name: 'Tentacles', image: '/images/characters/tentacles.jpg', isAdult: true },
      { name: 'Tomboy', image: '/images/characters/tomboy.jpg', isAdult: false },
      { name: '1Futanari,futanari', image: '/images/characters/futa.jpg', isAdult: true },
      { name: '2girls,girls', image: '/images/characters/girls.jpg', isAdult: false },
      { name: '1mom,1little son', image: '/images/characters/momson.jpg', isAdult: false },
      { name: '2girls,milfs', image: '/images/characters/milfs.jpg', isAdult: true },
      { name: 'gyaru', image: '/images/characters/gyaru.jpg', isAdult: false },
      { name: 'draenei from warcraft', image: '/images/characters/draenei.jpg', isAdult: false },
      { name: 'Blood elf from warcraft', image: '/images/characters/bloodelf.jpg', isAdult: false },
      { name: 'Night elf from warcraft', image: '/images/characters/nightelf.jpg', isAdult: false },
      { name: 'Dryad', image: '/images/characters/dryad.jpg', isAdult: false },
    ],
    overwatch: [
      { name: 'd.va from Overwatch', image: '/images/characters/diva.jpg', isAdult: false },
      { name: 'Mercy', image: '/images/characters/mercy.jpg', isAdult: false },
      { name: 'Widowmaker', image: '/images/characters/widowmaker.jpg', isAdult: false },
      { name: 'Mei from Overwatch', image: '/images/characters/mei.jpg', isAdult: false },
      { name: 'Sombra', image: '/images/characters/sombra.jpg', isAdult: false },
      { name: 'Tracer from overwatch', image: '/images/characters/tracer.jpg', isAdult: false },
      { name: 'Symmetra', image: '/images/characters/symmetra.jpg', isAdult: false },
      { name: 'Pharah', image: '/images/characters/pharah.jpg', isAdult: false },
      { name: 'Kiriko(Overwatch)', image: '/images/characters/kiriko.jpg', isAdult: false },
    ],  
    pokemon: [
      { name: 'Misty from Pokemon', image: '/images/characters/misty.jpg', isAdult: false },
      { name: 'Cynthia From Pokemon', image: '/images/characters/cynthia.jpg', isAdult: false },
      { name: 'Jessie from team rocket', image: '/images/characters/jessie.jpg', isAdult: false },
      { name: 'Rosa from Pokémon', image: '/images/characters/rosa.jpg', isAdult: false },
      { name: 'Erika from Pokémon', image: '/images/characters/erika.jpg', isAdult: false },
      { name: 'Skyla from Pokémon', image: '/images/characters/skyla.jpg', isAdult: false },
      { name: 'Hex maniac from Pokémon', image: '/images/characters/hex.jpg', isAdult: false },
      { name: 'Jenny from Pokémon', image: '/images/characters/jenny.jpg', isAdult: false },
      { name: 'Elesa from Pokémon', image: '/images/characters/elesa.jpg', isAdult: false },
      { name: 'Lillie from Pokémon', image: '/images/characters/lillie.jpg', isAdult: false },
      { name: 'iono from pokemon', image: '/images/characters/iono.jpg', isAdult: false },
      { name: 'Candice from pokemon', image: '/images/characters/candice.jpg', isAdult: false },
      { name: 'delia ketchum from pokemon', image: '/images/characters/delia.jpg', isAdult: false },
      { name: 'Lana mom from pokemon', image: '/images/characters/lana.jpg', isAdult: false },
      { name: 'Sonia from pokemon', image: '/images/characters/sonia.jpg', isAdult: false },
      { name: 'Dendra from pokemon', image: '/images/characters/dendra.jpg', isAdult: false },
      { name: 'Hilda from pokemon', image: '/images/characters/hildap.jpg', isAdult: false },
      { name: 'Marnie from pokemon', image: '/images/characters/marnie.jpg', isAdult: false },
      { name: 'dawn from pokemon', image: '/images/characters/dawn.jpg', isAdult: false },
      { name: 'Bea from pokemon', image: '/images/characters/bea.jpg', isAdult: false },
      { name: 'clair from pokemon', image: '/images/characters/clair.jpg', isAdult: false },
      { name: 'rika from pokemon', image: '/images/characters/rika.jpg', isAdult: false },
      { name: 'klara from pokemon', image: '/images/characters/klara.jpg', isAdult: false }, 
      { name: 'serena from pokemon', image: '/images/characters/serena.jpg', isAdult: false },
      { name: 'iris from pokmon', image: '/images/characters/iris.jpg', isAdult: false },
      { name: 'oleana from pokemon', image: '/images/characters/oleana.jpg', isAdult: false },
      { name: 'katarina claes', image: '/images/characters/katarina.jpg', isAdult: false },


    ],
    starrail:[
      { name: 'Asta from Honkai: Star Rail', image: '/images/characters/asta.jpg', isAdult: false },
      { name: 'Acheron', image: '/images/characters/acheron.jpg', isAdult: false },
      { name: 'Black Swan', image: '/images/characters/swan.jpg', isAdult: false },
      { name: 'Bronya', image: '/images/characters/bronya.jpg', isAdult: false },
      { name: 'Firefly from Honkai: Star Rail', image: '/images/characters/firefly.jpg', isAdult: false },
      { name: 'Fu Xuan', image: '/images/characters/fu.jpg', isAdult: false },
      { name: 'Guinaifen from Honkai: Star Rail', image: '/images/characters/guinaifen.jpg', isAdult: false },
      { name: 'Hanya from Honkai: Star Rail', image: '/images/characters/hanya.jpg', isAdult: false },
      { name: 'Herta', image: '/images/characters/herta.jpg', isAdult: false },
      { name: 'Himeko from Honkai: Star Rail', image: '/images/characters/himeko.jpg', isAdult: false },
      { name: 'Kafka from Honkai: Star Rail', image: '/images/characters/kafka.jpg', isAdult: false },
      { name: 'March 7th from Honkai: Star Rail', image: '/images/characters/march.jpg', isAdult: false },
      { name: 'Pela from Honkai: Star Rail', image: '/images/characters/pela.jpg', isAdult: false },
      { name: 'Qingque from Honkai: Star Rail', image: '/images/characters/qingque.jpg', isAdult: false },
      { name: 'Robin from Honkai: Star Rail', image: '/images/characters/robin.jpg', isAdult: false },
      { name: 'Ruan Mei from Honkai: Star Rail', image: '/images/characters/ruan.jpg', isAdult: false },
      { name: 'Seele', image: '/images/characters/seele.jpg', isAdult: false },
      { name: 'Silver Wolf', image: '/images/characters/wolf.jpg', isAdult: false },
      { name: 'Sparkle from Honkai: Star Rail', image: '/images/characters/sparkle.jpg', isAdult: false },
      { name: 'Jingliu', image: '/images/characters/jingliu.jpg', isAdult: false }, 
      { name: 'Tingyun', image: '/images/characters/tingyun.jpg', isAdult: false },
         
    ],
  };

  const normalizedAnime = anime?.toLowerCase().replace(/\s+/g, '');
  const characters = charactersByAnime[normalizedAnime] || [];

  const handleCharacterSelect = async (character) => {
    if (character.isAdult && telegramUser) {
      setIsChecking(true);
      const isSubscribed = await checkSubscription(telegramUser.id);
      setIsChecking(false);
      if (!isSubscribed) {
        setShowModal(true);
        return;
      }
    }
    setSelectedCharacter(character);
    navigate(`/costumes/${normalizedAnime}`);
  };

  if (!telegramUser) {
    return (
      <div className="min-h-screen bg-[#171f14] flex items-center justify-center">
        <p className="text-white text-lg">Please open this app in Telegram.</p>
      </div>
    );
  }

  if (!selectedAnime || selectedAnime.name.toLowerCase().replace(/\s+/g, '') !== normalizedAnime) {
    navigate('/');
    return null;
  }

  return (
    <div
      className="relative flex size-full min-h-screen flex-col bg-[#171f14] dark justify-between group/design-root overflow-x-hidden"
      style={{ fontFamily: 'Manrope, "Noto Sans", sans-serif' }}
    >
      <div>
        <div className="flex items-center bg-[#171f14] p-4 pb-2 justify-between">
          <div
            className="text-white flex size-12 shrink-0 items-center cursor-pointer"
            onClick={() => navigate('/')}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" fill="currentColor" viewBox="0 0 256 256">
              <path d="M224,128a8,8,0,0,1-8,8H59.31l58.34,58.34a8,8,0,0,1-11.32,11.32l-72-72a8,8,0,0,1,0-11.32l72-72a8,8,0,0,1,11.32,11.32L59.31,120H216A8,8,0,0,1,224,128Z"></path>
            </svg>
          </div>
          <h2 className="text-white text-lg font-bold leading-tight tracking-[-0.015em] flex-1 text-center pr-12">
            Select Character
          </h2>
        </div>
        <div className="grid grid-cols-[repeat(auto-fit,minmax(158px,1fr))] gap-3 p-4">
          {characters.length > 0 ? (
            characters.map((character) => (
              <div
                key={character.name}
                className={`flex flex-col gap-3 rounded-lg border p-2 cursor-pointer ${
                  character.isAdult && !telegramUser?.isSubscribed ? 'opacity-50 cursor-not-allowed' : 'border-[#445c3d] hover:bg-[#2e3a2b]'
                }`}
                onClick={() => !isChecking && handleCharacterSelect(character)}
              >
                <img
                  src={character.image}
                  alt={character.name}
                  className="w-32 h-32 object-cover rounded-xl"
                  onError={(e) => {
                    console.error(`Failed to load image: ${character.image}`);
                    e.target.src = '/images/fallback-image.jpg';
                  }}
                />
                <p className="text-white text-base font-medium">{character.name}</p>
                {character.isAdult && (
                  <span className="absolute top-2 right-2 text-red-500 text-xs font-bold">18+</span>
                )}
              </div>
            ))
          ) : (
            <div className="text-white text-center col-span-full">No characters available for this anime.</div>
          )}
        </div>
      </div>
      {/* Модальное окно */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-[#222e1f] p-6 rounded-lg max-w-sm w-full text-center">
            <h3 className="text-white text-lg font-bold mb-4">Subscription required</h3>
            <p className="text-gray-300 mb-6">This content is available to subscribers only. Please subscribe.</p>
            <div className="flex gap-4 justify-center">
              <button
                className="px-4 py-2 bg-[#445d3e] text-white rounded hover:bg-[#556b4e]"
                onClick={() => setShowModal(false)}
              >
                Close
              </button>
              <button
                className="px-4 py-2 bg-[#a4be9d] text-[#171f14] rounded hover:bg-[#b8d0b2]"
                onClick={() => {
                  setShowModal(false);
                  window.open('https://t.me/AniGenerator_bot?', '_blank'); // Ссылка на бота подписки
                }}
              >
                Subscribe now
              </button>
            </div>
          </div>
        </div>
      )}
      <div className="flex gap-2 border-t border-[#2f402b] bg-[#222e1f] px-4 py-3">
        <a href="/" className="flex flex-1 flex-col items-center justify-end gap-1 text-white">
          <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" fill="currentColor" viewBox="0 0 256 256">
            <path d="M224,115.55V208a16,16,0,0,1-16,16H168a16,16,0,0,1-16-16V168a8,8,0,0,0-8-8H112a8,8,0,0,0-8,8v40a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V115.55a16,16,0,0,1,5.17-11.78l80-75.48.11-.11a16,16,0,0,1,21.53,0,1.14,1.14,0,0,0,.11.11l80,75.48A16,16,0,0,1,224,115.55Z"></path>
          </svg>
        </a>
        <a href="#" className="flex flex-1 flex-col items-center justify-end gap-1 text-[#a4be9d]">
          <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" fill="currentColor" viewBox="0 0 256 256">
            <path d="M229.66,218.34l-50.07-50.06a88.11,88.11,0,1,0-11.31,11.31l50.06,50.07a8,8,0,0,0,11.32-11.32ZM40,112a72,72,0,1,1,72,72A72.08,72.08,0,0,1,40,112Z"></path>
          </svg>
        </a>
        <a href="#" className="flex flex-1 flex-col items-center justify-end gap-1 text-[#a4be9d]">
          <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" fill="currentColor" viewBox="0 0 256 256">
            <path d="M216,104H102.09L210,75.51a8,8,0,0,0,5.68-9.84l-8.16-30a15.93,15.93,0,0,0-19.42-11.13L35.81,64.74a15.75,15.75,0,0,0-9.7,7.4,15.51,15.51,0,0,0-1.55,12L32,111.56c0,.14,0,.29,0,.44v88a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V112A8,8,0,0,0,216,104ZM136.44,54.72,164.57,71l-58.90,15.55L77.55,70.27ZM208,200H48V120H208v80Z"></path>
          </svg>
        </a>
        <a href="#" className="flex flex-1 flex-col items-center justify-end gap-1 text-[#a4be9d]">
          <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" fill="currentColor" viewBox="0 0 256 256">
            <path d="M230.92,212c-15.23-26.33-38.7-45.21-66.09-54.16a72,72,0,1,0-73.66,0C63.78,166.78,40.31,185.66,25.08,212a8,8,0,1,0,13.85,8c18.84-32.56,52.14-52,89.07-52s70.23,19.44,89.07,52a8,8,0,1,0,13.85-8ZM72,96a56,56,0,1,1,56,56A56.06,56.06,0,0,1,72,96Z"></path>
          </svg>
        </a>
      </div>
    </div>
  );
};

export default CharacterSelect;